import { gql } from "@apollo/client";
import CompanySubscription from "~/lib/queries/fragments/CompanySubscription";
import StripeChargeFields from "~/lib/queries/fragments/StripeChargeFields";
import StripeInvoiceFields from "~/lib/queries/fragments/StripeInvoiceFields";
import StripePlanFields from "~/lib/queries/fragments/StripePlanFields";
import CompanyPlanUsageFields from "~/lib/queries/fragments/CompanyPlanUsageFields";
import CompanyPlanFields from "~/lib/queries/fragments/CompanyPlanFields";

export default gql`
  query CompanyAccountBillingInfo($slug: String!) {
    company(slug: $slug) {
      _id
      slug
      name
      canEarnCreditsUntil
      isDisruptor
      usersCanAccessAccountPage
      usersCanRequestContentTranslation
      stripePlan {
        ...StripePlanFields
      }
      planUsage {
        ...CompanyPlanUsageFields
      }
      plan {
        ...CompanyPlanFields
      }
      charges {
        ...StripeChargeFields
      }
      invoices {
        ...StripeInvoiceFields
      }
      billing {
        card {
          brand
          lastFourDigits
          expirationMonth
          expirationYear
        }
      }
      balanceTransactions {
        type
        amount
        government {
          _id
          name
        }
        inviter {
          _id
          fullName
        }
        endingBalance
        description
        createdAt
      }
      sponsoringSales {
        _id
        description
        type
        sponsorshipLevel
        includedCollections {
          _id
          name
          slug
        }
        price
        isActive
        paymentSchedule
        createdAt
        updatedAt
        ... on RecurringCollectionSponsoringSale {
          _id
          renewsAt
          cancelsAt
        }
        ... on LumpSumCollectionSponsoringSale {
          _id
          expirationDate
        }
      }
      ...CompanySubscription
    }
  }

  ${CompanySubscription}
  ${StripeChargeFields}
  ${StripeInvoiceFields}
  ${StripePlanFields}
  ${CompanyPlanUsageFields}
  ${CompanyPlanFields}
`;
